import { render, staticRenderFns } from "./NumberAnvisaField.vue?vue&type=template&id=05f3cd84"
import script from "./NumberAnvisaField.vue?vue&type=script&lang=js"
export * from "./NumberAnvisaField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports